interface InputErrorMessageProps {
  message?: string | null;
  className?: string;
  id?: string;
}

const InputErrorMessage = ({
  message,
  className = '',
  id,
}: InputErrorMessageProps) => {
  if (!message) {
    return null;
  }

  return (
    <div
      id={id}
      role="alert"
      aria-live="polite"
      className={`mt-2 small text-danger ${className}`.trim()}
    >
      {message}
    </div>
  );
};

export default InputErrorMessage;
